<template>
    <div class="layer">
        <div class="wrap">
            <div id="header">
                <div class="header_wrap">
                    <button type="button" class="menu_btn" @click="$router.back()">
                        <img src="@/assets/common/hd_prev_btn.png" alt="" />
                    </button>
                    <span class="logo">META HEALTH</span>
                </div>
            </div>
            <div class="content">
                <p class="page_title2">
                    <b>회원가입 정보</b>를 <br> 입력해주세요!
                </p>
                <form action="#n" method="post" id="user_form" class="user_step_form">
                    <div class="user_step_box" style="display: block;">
                        <div class="input_with_title">
                            <p class="tit">이메일</p>
                            <input id="userEmail" type="email" v-model="state.email" @input="emailPatternCheck"
                                @keydown.enter="nextBtn">
                        </div>
                        <p class="verf_txt" :class="check.isExistEmail ? 'success' : 'fail'" style="display: block;">
                            {{ state.excistText }}</p>
                    </div>
                    <div class="user_step_box" :style="state.inputNum >= 1 ? 'display:block' : ''">
                        <div class="input_with_title">
                            <p class="tit">비밀번호</p>
                            <input id="userPassword" type="password" v-model="state.pw" placeholder="비밀번호"
                                @input="passwordCheck" autoComplete="off" />
                            <span class="input_info">대소문자+숫자+특수문자 8~15글자</span>
                        </div>
                        <p class="verf_txt fail" v-if="!check.passwordPetern" style="display: block">
                            올바른 비밀번호 형식이 아닙니다.
                        </p>
                        <div class="input_with_title">
                            <p class="tit">비밀번호확인</p>
                            <input type="password" v-model="state.pw_check" @input="passwordCheck" autoComplete="off"
                                @keydown.enter="nextBtn" />
                        </div>
                        <p class="verf_txt fail" v-if="!check.samePassword" style="display: block">
                            비밀번호가 일치하지 않습니다.
                        </p>
                    </div>
                    <div class="user_step_box" :style="state.inputNum >= 2 ? 'display:block' : ''">
                        <div class="input_flex_box">
                            <div class="input_with_title">
                                <p class="tit">이름</p>
                                <input id="userFirstName" type="text" :value="state.firstName" @input="firstNameChange">
                            </div>
                            <div class="input_with_title">
                                <p class="tit">성</p>
                                <input type="text" :value="state.lastName" @input="lastNameChange"
                                    @keydown.enter="nextBtn">
                            </div>
                        </div>
                    </div>
                    <div class="user_step_box" :style="state.inputNum >= 3 ? 'display:block' : ''">
                        <div class="input_with_title">
                            <p class="tit">전화번호</p>
                            <input id="userPhone" type="tel" @input="phonePaternCheck" v-model="state.phone"
                                placeholder="전화번호" @keydown.enter="nextBtn" />
                            <span class="input_info">숫자만 입력</span>
                        </div>
                        <p class="verf_txt fail" v-if="!check.phone" style="display: block">
                            전화번호가 정확한지 확인해 주세요.
                        </p>
                    </div>
                    <div class="user_step_box" :style="state.inputNum >= 4 ? 'display:block' : ''">
                        <div class="input_with_title">
                            <p class="tit">성별</p>
                            <div class="radio_wrap">
                                <label class="radio" for="gender1">
                                    <input type="radio" v-model="state.gender" value="0" name="gender" id="gender1"
                                        @keydown.enter="nextBtn" />
                                    <b></b>
                                    <span>남</span>
                                </label>
                                <label class="radio" for="gender2">
                                    <input type="radio" v-model="state.gender" value="1" name="gender" id="gender2"
                                        @keydown.enter="nextBtn" />
                                    <b></b>
                                    <span>여</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="user_step_box" :style="state.inputNum >= 5 ? 'display:block' : ''">
                        <div class="input_flex_box">
                            <div class="input_with_title">
                                <p class="tit">키</p>
                                <input id="userHeight" type="number" v-model="state.height" @input="heightWeigthCheck">
                                <span class="input_unit">cm</span>
                            </div>
                            <div class="input_with_title">
                                <p class="tit">몸무게</p>
                                <input id="userWeight" type="number" v-model="state.weigth" @input="heightWeigthCheck">
                                <span class="input_unit">kg</span>
                            </div>
                        </div>
                    </div>
                    <button type="button" id="submit_btn" :style="check.isNextBtn ? 'display:block' : ''"
                        @click="nextBtn">다음</button>
                    <button type="button" id="submit_btn" :style="check.isSubmitBtn ? 'display:block' : ''"
                        @click="checkForm">회원가입</button>
                </form>
            </div>
        </div>
    </div>
    <ModalComponent :show="state.isModalOpen" :yes="modal.confirm" :no="modal.cancel" :content="modal.content"
        @close="modalClose"> </ModalComponent>
</template>

<script lang="ts" config>
import { reactive, router, apiService, res, ModalComponent, onMounted, userStore, returnCode, watch } from "@/BaseComponent";
import { nextTick } from "vue";

export default {
    components: {
        ModalComponent,
    },
    setup() {
        const { changeCode } = returnCode();
        const user = userStore();
        const state = reactive({
            inputNum: 0 as number,
            email: "" as string,
            pw: "" as string,
            pw_check: "" as string,
            firstName: "" as string,
            lastName: "" as string,
            phone: "" as string,
            weigth: "" as string,
            height: "" as string,
            gender: "0" as string,
            excistText: "이메일을 입력해주세요" as string,
            checkInfo: false as boolean,
            showDomain: true as boolean,
            isModalOpen: false as boolean,
            isProfileImg: false as boolean,
        });

        const check = reactive({
            select: false as boolean,
            phone: false as boolean,
            emailPettern: false as boolean,
            passwordPetern: false as boolean,
            samePassword: false as boolean,
            existEmail: false as boolean,
            isExistEmail: false as boolean,
            isNextBtn: true as boolean,
            isSubmitBtn: false as boolean,
        });

        const modal = reactive({
            content: "" as string,
            confirm: "" as string,
            cancel: "" as string,
            actionCode: 0 as number
        });

        onMounted(() => {
            if (user.token) {
                router.replace("/");
            }
        });
        //input 형식 확인
        const passwordCheck = () => {
            pwCheck();
            passwordPaternCheck();
        };

        const passwordPaternCheck = () => {
            const pattern = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,15}$/;
            if (pattern.test(state.pw)) {
                check.passwordPetern = true;
            } else {
                check.passwordPetern = false;
            }
        };
        const pwCheck = () => {
            state.inputNum = 1;
            check.isNextBtn = false;
            check.isSubmitBtn = false;
            if (state.pw !== "" && state.pw_check !== "") {
                if (state.pw_check != state.pw) {
                    check.samePassword = false;
                    check.isNextBtn = false;
                } else if (state.pw_check === state.pw) {
                    check.samePassword = true;
                    if (check.passwordPetern === true) {
                        check.isNextBtn = true;
                    }
                }
            }
        };
        const phonePaternCheck = () => {
            state.inputNum = 3;
            check.isNextBtn = false;
            check.isSubmitBtn = false;
            const phoneNumberPattern1 = /^01[0-1,7,9]\d{7,8}$/;
            if (phoneNumberPattern1.test(state.phone)) {
                check.phone = true;
                check.isNextBtn = true;
            } else {
                check.phone = false;
                check.isNextBtn = false;
            }
        };

        const emailPatternCheck = () => {
            check.existEmail = false;
            check.isNextBtn = true;
            check.isExistEmail = false;
            check.isSubmitBtn = false;
            state.inputNum = 0;
            if (state.email != "" && state.email != null) {
                const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                if (emailPattern.test(state.email)) {
                    check.emailPettern = true;
                    check.isNextBtn = true;
                    state.excistText = "";
                } else {
                    check.emailPettern = false;
                    state.excistText = "이메일 형식을 확인해주세요";
                }
            } else {
                state.excistText = "이메일을 입력해주세요";
            }
        };


        const lastNameChange = (e: any) => {
            state.lastName = e.target.value;
            nameInputCheck();
        };
        const firstNameChange = (e: any) => {
            state.firstName = e.target.value;
            nameInputCheck();
        };
        const nameInputCheck = () => {
            state.inputNum = 2;
            check.isNextBtn = false;
            check.isSubmitBtn = false;
            if (state.lastName !== "" && state.firstName !== "") {
                check.isNextBtn = true;
            } else {
                check.isNextBtn = false;
            }
        };

        const heightWeigthCheck = () => {
            if (state.weigth !== "" && state.height !== "") {
                check.isSubmitBtn = true;
            } else {
                check.isSubmitBtn = false;
            }
        };

        //input형식, 필수값 확인
        const checkForm = (e: any) => {
            e.preventDefault();
            if (check.existEmail === true) {
                if (state.pw_check === state.pw && check.samePassword === true) {
                    if (state.firstName !== "" && state.lastName !== "") {
                        if (check.phone === true) {
                            if (state.height !== "" && state.weigth !== "") {
                                save();
                            } else {
                                modal.content = "키와 몸무게를 모두 입력해주세요";
                                modal.cancel = "확인";
                                state.isModalOpen = true;
                            }
                        } else {
                            modal.content = "전화번호를 확인해주세요";
                            modal.cancel = "확인";
                            state.isModalOpen = true;
                        }
                    } else {
                        modal.content = "이름과 성을 확인해주세요";
                        modal.cancel = "확인";
                        state.isModalOpen = true;
                    }
                } else {
                    modal.content = "비밀번호를 확인해주세요";
                    modal.cancel = "확인";
                    state.isModalOpen = true;
                }
            } else {
                modal.content = '이메일을 확인해주세요';
                modal.cancel = "확인";
                state.isModalOpen = true;
            }
        };

        //api 호출
        const save = async () => {
            const param: FormData = new FormData();
            param.append("id", state.email);
            param.append("pw", state.pw);
            param.append("name", state.lastName + state.firstName);
            param.append("phone", state.phone);
            param.append("weight", state.weigth);
            param.append("height", state.height);
            param.append("gender", state.gender);

            const response = await apiService.base.join(param);
            if (response.returnCode === 0) {
                router.replace('/successJoin');
            } else {
                modal.content = changeCode(response.returnCode);
                modal.cancel = "확인";
                state.isModalOpen = true;
            }
        };

        const existEmail = async () => {
            if (state.email !== "" && check.emailPettern === true) {
                let res: res = await apiService.base.existId(state.email);
                if (res.returnCode === 0) {
                    check.existEmail = true;
                    check.isExistEmail = true;
                    state.excistText = "사용 가능한 이메일입니다.";
                    if (state.pw !== "" && state.pw_check !== "" && state.pw === state.pw_check) {
                        check.isNextBtn = true;
                    } else {
                        check.isNextBtn = false;
                    }
                    state.inputNum++;
                } else if (res.returnCode === 14) {
                    check.existEmail = false;
                    check.isExistEmail = false;
                    check.isNextBtn = true;
                    state.excistText = "이미 등록된 이메일입니다.";
                }
            } else {
                modal.content = "이메일을 확인해주세요";
                modal.cancel = "확인";
                state.isModalOpen = true;
            }
        };

        const modalClose = (result: boolean) => {
            state.isModalOpen = false;
            if (result) {
                switch (modal.actionCode) {
                    case 1:
                        router.replace('/login');
                        break;

                    default:
                        break;
                }
            }
        };

        const focusNextInput = async (inputId: string) => {
            await nextTick();
            const inputElement = document.getElementById(inputId) as HTMLInputElement | null;
            inputElement?.focus();
        };

        const nextBtn = async () => {
            switch (state.inputNum) {
                case 0:
                    await existEmail();
                    focusNextInput('userPassword');
                    break;
                case 1:
                    if (state.pw_check === state.pw && check.passwordPetern) {
                        state.inputNum++;
                        check.isNextBtn = !!(state.firstName && state.lastName);
                        focusNextInput('userFirstName');
                    }
                    break;
                case 2:
                    if (state.firstName && state.lastName) {
                        state.inputNum++;
                        check.isNextBtn = !!state.phone;
                        focusNextInput('userPhone');
                    }
                    break;
                case 3:
                    if (state.phone) {
                        state.inputNum++;
                        check.isNextBtn = true;
                        focusNextInput('gender1');
                    }
                    break;
                case 4:
                    state.inputNum++;
                    check.isNextBtn = false;
                    if (state.height !== "" && state.weigth !== "") {
                        check.isSubmitBtn = true;
                    } else {
                        check.isSubmitBtn = false;
                    }
                    focusNextInput('userHeight');
                    break;
                default:
                    break;
            }
        };

        return {
            state,
            modal,
            check,
            router,
            save,
            pwCheck,
            passwordCheck,
            existEmail,
            phonePaternCheck,
            checkForm,
            nextBtn,
            emailPatternCheck,
            firstNameChange,
            lastNameChange,
            nameInputCheck,
            heightWeigthCheck,
            modalClose
        };
    },
};
</script>
